import queryString from 'query-string'

const allSpecialties = ['TODOS', 'GENERALISTA', 'ADULTO', 'PEDIATRIA']

const getAvailableSpecialties = () => {
  const parsed = queryString.parse(window.location.search)
  const auth = parsed.auth

  const validTokens = (process.env.REACT_APP_GENERALIST_AUTH_TOKENS || '')
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t)

  if (validTokens.includes(auth)) {
    return allSpecialties
  }

  return allSpecialties.filter((s) => s !== 'GENERALISTA')
}

export default getAvailableSpecialties()
